const Preloader = () => (
  <div className="top-[-23px] items-start relative flex left-0 w-full p-0 -ms-[28px]">
    <div className="shadow-[0_10px_40px_-10px_#fff] rounded-full top-0 h-1 w-full bg-primary animate-[load_1s_normal_forwards]"></div>
  </div>
)

export default Preloader